module.exports = __webpack_public_path__ + "img/amx_logo.4ac6bf46.jpg";